import { Container } from "react-bootstrap";
import Header from "../../Components/Header";
import Aside from "../../Components/Aside";
import Loader from "Components/Loader";
import AutoBeepPlayer from "Components/BeepSound";
import MqttConnect from "services/mqtt";
import PosSubscriptionNotice from "Components/InvoiceNotice";
import { Helmet } from "react-helmet";

const AuthorizeLayout = ({ sideBarState, ...props }: any) => {
  return (
    <div className="app-wrapper">
      <Helmet>
        <title>Foodslift</title>
      </Helmet>
      <PosSubscriptionNotice />
      <Container fluid className="authLayout">
        <Header />
        <Aside />
        <Loader />
        <MqttConnect />
        <AutoBeepPlayer />
        <div className="content">{props.children}</div>
      </Container>
    </div>
  );
};

export default AuthorizeLayout;
